import React from 'react';

import ActivityFeedbackDialog from './ActivityFeedbackDialog';
import CreateGrowthDialog from './CreateGrowthDialog';
import GrowthFeedbackDialog from './GrowthFeedbackDialog';

const GrowthDialogs = () => {
  return (
    <>
      <CreateGrowthDialog />
      <GrowthFeedbackDialog />
      <ActivityFeedbackDialog />
    </>
  );
};

export default GrowthDialogs;
